/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentDetail } from './TournamentDetail';
import {
    TournamentDetailFromJSON,
    TournamentDetailFromJSONTyped,
    TournamentDetailToJSON,
    TournamentDetailToJSONTyped,
} from './TournamentDetail';
import type { TournamentMeta } from './TournamentMeta';
import {
    TournamentMetaFromJSON,
    TournamentMetaFromJSONTyped,
    TournamentMetaToJSON,
    TournamentMetaToJSONTyped,
} from './TournamentMeta';
import type { ResourcePermissionsResponse } from './ResourcePermissionsResponse';
import {
    ResourcePermissionsResponseFromJSON,
    ResourcePermissionsResponseFromJSONTyped,
    ResourcePermissionsResponseToJSON,
    ResourcePermissionsResponseToJSONTyped,
} from './ResourcePermissionsResponse';

/**
 * 
 * @export
 * @interface TournamentSummary
 */
export interface TournamentSummary {
    /**
     * 
     * @type {string}
     * @memberof TournamentSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentSummary
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentSummary
     */
    location?: string;
    /**
     * 
     * @type {Date}
     * @memberof TournamentSummary
     */
    date?: Date | null;
    /**
     * Inclusive final tournament day; defaults to date for single-day tournaments.
     * @type {Date}
     * @memberof TournamentSummary
     */
    endDate?: Date | null;
    /**
     * 
     * @type {TournamentMeta}
     * @memberof TournamentSummary
     */
    meta?: TournamentMeta;
    /**
     * 
     * @type {Array<object>}
     * @memberof TournamentSummary
     */
    teams?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof TournamentSummary
     */
    matches?: Array<object>;
    /**
     * 
     * @type {TournamentDetail}
     * @memberof TournamentSummary
     */
    details?: TournamentDetail;
    /**
     * 
     * @type {Array<object>}
     * @memberof TournamentSummary
     */
    categories?: Array<object>;
    /**
     * 
     * @type {ResourcePermissionsResponse}
     * @memberof TournamentSummary
     */
    permissions?: ResourcePermissionsResponse;
}

/**
 * Check if a given object implements the TournamentSummary interface.
 */
export function instanceOfTournamentSummary(value: object): value is TournamentSummary {
    return true;
}

export function TournamentSummaryFromJSON(json: any): TournamentSummary {
    return TournamentSummaryFromJSONTyped(json, false);
}

export function TournamentSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'location': json['location'] == null ? undefined : json['location'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'meta': json['meta'] == null ? undefined : TournamentMetaFromJSON(json['meta']),
        'teams': json['teams'] == null ? undefined : json['teams'],
        'matches': json['matches'] == null ? undefined : json['matches'],
        'details': json['details'] == null ? undefined : TournamentDetailFromJSON(json['details']),
        'categories': json['categories'] == null ? undefined : json['categories'],
        'permissions': json['permissions'] == null ? undefined : ResourcePermissionsResponseFromJSON(json['permissions']),
    };
}

export function TournamentSummaryToJSON(json: any): TournamentSummary {
    return TournamentSummaryToJSONTyped(json, false);
}

export function TournamentSummaryToJSONTyped(value?: TournamentSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'location': value['location'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'meta': TournamentMetaToJSON(value['meta']),
        'teams': value['teams'],
        'matches': value['matches'],
        'details': TournamentDetailToJSON(value['details']),
        'categories': value['categories'],
        'permissions': ResourcePermissionsResponseToJSON(value['permissions']),
    };
}

